module.exports = new __parcel__URL__("moon.bbd71798.svg").toString();